
// Design System
import Checkbox from 'jl-design-system/components/checkbox/Checkbox';
import { EditOutlined } from 'jl-design-system/components/icons/EditOutlined';
import { TertiaryButton } from 'jl-design-system/elements/button/Button';

// Types
import { ToggleProposedBillingAddressProps } from './ToggleProposedBillingAddress.types';

// Component
import BodyText from '../../../body-text';
import Container from '../../../container';
import DisplayAddress from '../../../display-address/DisplayAddress';

const ToggleProposedBillingAddress = ({
  action,
  addressAsLabel = false,
  deliveryAddress = {},
  disabled = false,
  isSignedInWithData = false,
  useProposedBillingAddress = true,
}: ToggleProposedBillingAddressProps) => {
  const getCheckboxLabel = () => {
    if (!addressAsLabel) {
      return 'Same as delivery details';
    }

    return (
      <BodyText
        marginBottom="2"
        tag="div"
        testId="address-as-label"
      >
        <DisplayAddress {...deliveryAddress} data-testid="toggle-billing-address-display-address" inline />
      </BodyText>
    );
  };

  return (
    <Container data-testid="toggle-proposed-billing-address">
      <Container marginBottom="2">
        <Checkbox
          checked={useProposedBillingAddress}
          disabled={disabled}
          isControlled
          label={getCheckboxLabel()}
          name="toggle-delivery-address-checkbox"
          onChange={action}
        />
      </Container>

      {useProposedBillingAddress && !addressAsLabel && !isSignedInWithData && (
        <BodyText
          marginBottom="2"
          tag="div"
          testId="same-as-delivery"
        >
          <DisplayAddress {...deliveryAddress} inline />
        </BodyText>
      )}

      {useProposedBillingAddress && !isSignedInWithData && (
        <TertiaryButton
          IconComponent={EditOutlined}
          data-testid="enter-new-address-button"
          disabled={disabled}
          onClick={action}
          small
        >
          Enter new details
        </TertiaryButton>
      )}
    </Container>
  );
};

export default ToggleProposedBillingAddress;
